import React, {useState, useEffect} from 'react'
import { Link, useLocation } from 'react-router-dom'
import '../CSS/Navbar.css'

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [clicked, setClicked] = useState('carousel');
    const location = useLocation();
  
    useEffect(() => {
      const searchParams = new URLSearchParams(location.search);
      const TypeParam = searchParams.get('Type');
      if (TypeParam) {
        setClicked(TypeParam);
      }
    }, [location.search]);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
    
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setClicked(entry.target.getAttribute("id")); 
                    }
                });
            },
            { rootMargin: "-50px 0px -50px 0px", threshold: 0.1 } 
        );
    
        const sections = document.querySelectorAll("section");
        sections.forEach((section) => observer.observe(section));
    
        window.addEventListener("scroll", handleScroll);
    
        return () => {
            window.removeEventListener("scroll", handleScroll);
            sections.forEach((section) => observer.unobserve(section));
        };
    }, []);

    const closeNavbar = () => {
        if (window.matchMedia('(max-width: 991px)').matches) {
          const navbarToggler = document.querySelector('.navbar-toggler');
          if (navbarToggler) {
            navbarToggler.click();
          }
        }
    };

    return (
        <>
            <nav id="header" className={`navbar bg-white fixed-top ${scrolled ? "header-scrolled" : ""}`}>
                <div className="container d-flex justify-content-between align-items-center">
                    <div className="logo-heading">
                        <h1 className="logo me-auto"><Link to="/"><span>RAYAN</span> <i>Info Solutions</i></Link></h1>
                        <p>Destination For Your Technological Aspiration</p>
                    </div>
                    <ul className="nav-menu d-none d-lg-flex">
                        <li className={clicked === 'carousel' ? "active" : ""}><Link to="/" onClick={() => document.getElementById("carousel").scrollIntoView({ behavior: "smooth" })}>Home</Link></li>
                        <li className={clicked === 'AboutUs' ? "active" : ""}><Link to="/" onClick={() => document.getElementById("AboutUs").scrollIntoView({ behavior: "smooth" })}>About Us</Link></li>
                        <li className={clicked === 'Services' ? "active" : ""}><Link to="/" onClick={() => document.getElementById("Services").scrollIntoView({ behavior: "smooth" })}>Services</Link></li>
                        <li className={clicked === 'Solutions' ? "active drop-down" : "drop-down"}><Link to="">Solutions</Link>
                            <ul>
                                <li><Link to="/School">School Management Software</Link></li>
                                <li><Link to="/Health">Pathology Management Software</Link></li>
                                <li><Link to="/Hospital">Hospital Management Software</Link></li>
                                <li><Link to="/Tannery">Footwear Production Management Software</Link></li>
                                <li><Link to="#">Payroll Management Software</Link></li>
                                <li><Link to="#">Credit Cooperative Management Software</Link></li>
                                <li><Link to="#">Cold Store Management Software</Link></li>
                            </ul>
                        </li>
                        <li className={clicked === 'ContactUs' ? "active" : ""}><Link to="/" onClick={() => document.getElementById("ContactUs").scrollIntoView({ behavior: "smooth" })}>Contact Us </Link></li>
                    </ul>
                    <button className="navbar-toggler d-block d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="offcanvas offcanvas-end d-flex d-lg-none" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                        <div className="offcanvas-header">
                            <div className="logo-heading">
                                <h1 className="logo me-auto"><Link to="/"><span>RAYAN</span> <i>Info Solutions</i></Link></h1>
                                <p>Destination For Your Technological Aspiration</p>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div className="offcanvas-body">
                            <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                                <li className={clicked === 'carousel' ? "active" : ""} onClick={closeNavbar}><Link className="nav-link" to="/" onClick={() => document.getElementById("carousel").scrollIntoView({ behavior: "smooth" })}>Home</Link></li>
                                <li className={clicked === 'AboutUs' ? "nav-item active" : "nav-item"} onClick={closeNavbar}><Link className="nav-link" to="/" onClick={() => document.getElementById("AboutUs").scrollIntoView({ behavior: "smooth" })}>About Us</Link></li>
                                <li className={clicked === 'Services' ? "nav-item active" : "nav-item"} onClick={closeNavbar}><Link className="nav-link" to="/" onClick={() => document.getElementById("Services").scrollIntoView({ behavior: "smooth" })}>Services</Link></li>
                                <li className={clicked === 'Solutions' ? "active nav-item dropdown" : "nav-item dropdown"}>
                                    <span className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Solutions</span>
                                    <ul className="dropdown-menu">
                                        <li onClick={closeNavbar}><Link to="/School" className="dropdown-item">School Management Software</Link></li>
                                        <li onClick={closeNavbar}><Link to="/Health" className="dropdown-item">Pathology Management Software</Link></li>
                                        <li onClick={closeNavbar}><Link to="/Hospital" className="dropdown-item">Hospital Management Software</Link></li>
                                        <li onClick={closeNavbar}><Link to="/Tannery" className="dropdown-item">Footwear Production Management Software</Link></li>
                                        <li onClick={closeNavbar}><Link to="#" className="dropdown-item">Payroll Management Software</Link></li>
                                        <li onClick={closeNavbar}><Link to="#" className="dropdown-item">Credit Cooperative Management Software</Link></li>
                                        <li onClick={closeNavbar}><Link to="#" className="dropdown-item">Cold Store Management Software</Link></li>
                                    </ul>
                                </li>
                                <li className={clicked === 'ContactUs' ? "active" : ""} onClick={closeNavbar}><Link className="nav-link" to="/" onClick={() => document.getElementById("ContactUs").scrollIntoView({ behavior: "smooth" })}>Contact Us </Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    )
}
